// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active[data-v-8658e226] {\n  --tw-bg-opacity: 1;\n  background-color: rgba(239, 246, 255, var(--tw-bg-opacity));\n  border-left-color: #3b82f6; /* border-blue-500 */\n}\n.inActive[data-v-8658e226]:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgba(249, 250, 251, var(--tw-bg-opacity));\n  border-left-color: #d1d5db; /* border-gray-300 */\n}\n.inActive[data-v-8658e226] {\n  --tw-border-opacity: 1;\n  border-color: rgba(255, 255, 255, var(--tw-border-opacity));\n}\n", ""]);
// Exports
module.exports = exports;
